var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import id from "@irati/utils/id";
import Feed from "./Feed";
import { StyledTransition } from "./styled/TransitionFeed";
var TransitionFeed = function (props) {
    var before = props.before, timeout = props.timeout, className = props.className, arr = props.arr, onClick = props.onClick, isNew = props.isNew, Comp = props.component;
    var TransitionComponent = Comp;
    return (React.createElement(StyledTransition, { timeout: timeout },
        React.createElement(CSSTransition, { classNames: "transitionFeed", appear: true, timeout: timeout },
            React.createElement(Feed, { id: id("", props), isNew: isNew, className: className },
                before && before,
                React.createElement(TransitionGroup, null, arr.map(function (item, i) { return (React.createElement(CSSTransition, { key: item.uuid || i, classNames: "transitionFeed", appear: true, timeout: timeout },
                    React.createElement(TransitionComponent, { id: id("" + i, props), item: item, onClick: onClick }))); }))))));
};
TransitionFeed.defaultProps = {
    before: null,
    timeout: { enter: 500, exit: 500, appear: 500 },
    onClick: null,
    component: styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))),
    isNew: false,
    id: "feed"
};
export default TransitionFeed;
var templateObject_1;
